var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddressEdit = function SvgAddressEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1B1B1B",
    strokeWidth: 1.5,
    d: "M9.4 2.674a.75.75 0 0 1 1.024-.274l1.732 1a.75.75 0 0 1 .275 1.024L5.452 16.511a.75.75 0 0 1-.39.329l-1.467.54a.75.75 0 0 1-.997-.577l-.266-1.54a.75.75 0 0 1 .09-.502z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1B1B1B",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M9 17h9"
  })));
};
export default SvgAddressEdit;